import { ReactElement } from 'react';
import classnames from 'classnames';
import Table from '@material-ui/core/Table';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';

import { getSort } from '~/utils/sort';
import NoDataFound from '~/ui/components/reusable/NoDataFound';
import Item from './Item';

import { headCells } from './constants';
import { ISort } from '~/utils/sort/types';
import styles from './Table.module.scss';
import { IActivityLogList } from '~/services/api/activityLogs/types';
import { Order } from '~/types';

interface IProps {
  activityLogs: IActivityLogList[];
  sort: ISort;
  onSort: (sort: ISort) => void;
}

const TableComponent = ({ activityLogs, sort, onSort }: IProps): ReactElement => (
  <TableContainer>
    <Table>
      <TableHead>
        <TableRow>
          {headCells.map(headCell => (
            <TableCell
              key={headCell.id}
              width={headCell.width}
              align={headCell.align || 'inherit'}
              className={classnames({ [styles.cellCenter]: headCell.align === 'center' })}
            >
              {headCell.useSort ? (
                <TableSortLabel
                  active={sort.orderBy === headCell.id}
                  direction={
                    sort.orderBy === headCell.id && sort.isDescending ? Order.Desc : Order.Asc
                  }
                  onClick={() => onSort(getSort(sort, headCell.id))}
                >
                  {headCell.label}
                </TableSortLabel>
              ) : (
                headCell.label
              )}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {activityLogs.length ? (
          activityLogs.map(item => <Item key={item.patientId} activityLog={item} />)
        ) : (
          <TableRow>
            <TableCell colSpan={6}>
              <NoDataFound />
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  </TableContainer>
);

export default TableComponent;
